module.exports = __webpack_public_path__ + "img/nav-left.6183e9f0.png";